import { render } from "./DaysIndex.vue?vue&type=template&id=3fb7200b&scoped=true"
import script from "./DaysIndex.vue?vue&type=script&lang=js"
export * from "./DaysIndex.vue?vue&type=script&lang=js"

import "./DaysIndex.vue?vue&type=style&index=0&id=3fb7200b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb7200b"]])

export default __exports__